import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_PROCON } from 'services/_path';

// TYPES
import { Types } from './types';

// ACTIONS
import { classificacoesSuccess, classificacoesFailure } from './actions';

function* classificacoesRequest() {
	const response: ApiResponse = yield call(
		postApi,
		PATH_PROCON,
		`dominios/${CHANNEL}/classificacoes`,
		{},
	);

	if (response.status === 200) {
		yield put(classificacoesSuccess(response));
	} else {
		yield put(classificacoesFailure(response));
	}
}

export default all([
	takeLatest(Types.CLASSIFICACOES_REQUEST, classificacoesRequest),
]);
